import React, { useEffect, useState } from "react";
import { Text, View } from "../shared/Themed";
import { StyleSheet } from "react-native";
import Icons from "@expo/vector-icons/MaterialCommunityIcons";
import { ResponseSelectBox } from "../../models/response";

import DropDownPicker, { ItemType } from "react-native-dropdown-picker";
import { ReadOnlyProps } from "../../utils/templates";

interface Props {
  Items:
  | Array<Record<string, string>>
  | Array<string | number>
  | ItemType<string>[];
  required: boolean;
  title: string;
  placeholder: string;
  width: number | string;
  defaultOption?: ResponseSelectBox | string | null;
  onSelectedValue: (event: any) => void;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}

export const SelectBoxControl: React.FC<ReadOnlyProps<Props>> = (
  props: ReadOnlyProps<Props>
) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const [value, setValue] = useState(props.defaultOption);
  const [items, setItems] = useState(props.Items);

  const open = props.open !== undefined ? props.open : internalOpen;
  const setOpen = props.setOpen !== undefined ? props.setOpen : setInternalOpen;

  useEffect(() => {
    if (props.defaultOption) {
      setValue(props.defaultOption);
    } else {
      setValue("");
    }
  }, [props.defaultOption]);

  return (
    <View
      style={{
        flexDirection: "column",
        width: props.width as any,
        marginTop: 14,
        zIndex: open ? 1000 : 1,
        elevation: open ? 5 : 0 // For Android support
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 6 }}>
        <Text style={styles.label}>
          {props.title}
        </Text>
        {props.required && <Icons name="star" size={8} color="#EF4444" style={{ marginLeft: 4 }} />}
      </View>
      <View>
        <DropDownPicker
          schema={{
            label: "value",
            value: "key",
          }}
          open={open}
          value={value as string}
          setValue={setValue}
          items={items as ItemType<string>[]}
          setItems={setItems}
          setOpen={setOpen as any}
          onSelectItem={(val: any) => {
            props.onSelectedValue(val["key"]);
          }}
          placeholder={props.placeholder}
          placeholderStyle={styles.placeholderStyles}
          listMode="SCROLLVIEW"
          style={styles.dropdown}
          dropDownContainerStyle={styles.dropdownContainerStyle}
          showTickIcon={true}
          listItemContainerStyle={styles.listItemContainerStyle}
          listItemLabelStyle={styles.listItemLabelStyle}
          tickIconStyle={styles.tickIconStyle as any}
          itemSeparator={true}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    fontSize: 13,
    fontWeight: "600",
    color: "#374151",
    textAlign: "left",
  },
  dropdown: {
    backgroundColor: "#F9FAFB",
    borderWidth: 1,
    borderRadius: 8,
    borderColor: "#D1D5DB",
    height: 44,
    paddingHorizontal: 12,
  },
  placeholderStyles: {
    color: "#9CA3AF",
    fontSize: 14,
  },
  dropdownContainerStyle: {
    zIndex: 10000,
    backgroundColor: "#ffffff",
    borderColor: "#D1D5DB",
    borderRadius: 8,
  },
  listItemContainerStyle: {
    height: 44,
  },
  listItemLabelStyle: {
    fontSize: 14,
    color: "#111827",
    paddingHorizontal: 12,
  },
  tickIconStyle: {
    color: "#2563EB",
  },
});
